export default "__VITE_ASSET__BvFzZTPb__"